import { render, staticRenderFns } from "./eligibility-details.vue?vue&type=template&id=64974c2e&scoped=true&"
import script from "./eligibility-details.vue?vue&type=script&lang=js&"
export * from "./eligibility-details.vue?vue&type=script&lang=js&"
import style0 from "./eligibility-details.vue?vue&type=style&index=0&id=64974c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64974c2e",
  null
  
)

component.options.__file = "eligibility-details.vue"
export default component.exports